<template>
  <div
    class="z-footer-bar"
    :style="{
      width: isSideMenu()
        ? `calc(100% - ${sidebarOpened ? 256 : 80}px)`
        : '100%'
    }"
  >
    <div style="float: left">
      <slot name="extra">{{ extra }}</slot>
    </div>
    <div style="float: right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixin.js'

export default {
  name: 'FooterBar',
  mixins: [ mixin ],
  props: {
    extra: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.z-footer-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  padding: 0 24px;

  width: 100%;
  height: 56px;
  line-height: 56px;

  background: #fff;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.03);
  border-top: 1px solid #e8e8e8;
}
</style>
